import { Component, Inject, Input, OnInit } from '@angular/core';
import { NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export class ConfirmationDialog {
  title: string;
  message: string;
  yes: string;
  no: string;
  reason?:string
}
@Component({
  selector: 'app-confirmation-with-reason',
  templateUrl: './confirmation-with-reason.component.html',
  styleUrls: ['./confirmation-with-reason.component.scss']
})
export class ConfirmationWithReasonComponent implements OnInit {
  public form: UntypedFormGroup;

  dialogData :ConfirmationDialog = {
    title : '',
    message: '',
    yes: 'Yes',
    no: 'No',
    reason: ''
  };
 constructor(
   public dialogRef: MatDialogRef<ConfirmationWithReasonComponent>,
   @Inject(MAT_DIALOG_DATA) public data :ConfirmationDialog,
   public fb: UntypedFormBuilder,
 ) {
  this.form = this.fb.group({
    reason: [null, [Validators.required, Validators.maxLength(150)]],
  });
   if(data) {
     this.dialogData = data
   }
  }

 ngOnInit(): void {
 }
 dialogClose(value:any) {
   this.dialogRef.close(value);
 }
 submit(form: NgForm) {
  this.dialogRef.close({
    clicked: 'submit',
    form: form,
  });
}

}
